import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Navigate } from 'react-router-dom';
import api from './services/apiService';
import './scss/payment-success.scss';

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');
    const playerName = searchParams.get('player_name');
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState(null);
    const [errorDetails, setErrorDetails] = useState(null);
    const [isVerifying, setIsVerifying] = useState(true);

    useEffect(() => {
        // Prevent going back
        window.history.pushState(null, null, window.location.href);
        window.onpopstate = function() {
            window.history.pushState(null, null, window.location.href);
        };

        const verifyPayment = async () => {
            if (!sessionId) {
                setError('No session ID found');
                setIsVerifying(false);
                return;
            }

            try {
                const response = await api.post(`${process.env.REACT_APP_API_URL}/verify_payment.php`, {
                    sessionId: sessionId
                });

                if (response.data.success) {
                    setVerified(true);
                    // Redirect to fees page after 2 seconds only on success
                    setTimeout(() => {
                        navigate('/fees', { replace: true });
                    }, 2000);
                } else {
                    setError('Payment verification failed');
                    setErrorDetails(response.data.error || 'Unknown error');
                    setIsVerifying(false);
                    // No automatic redirect on error
                }
            } catch (error) {
                setError(error.message);
                setErrorDetails(
                    error.response ? JSON.stringify(error.response.data, null, 2) : 'No additional details available'
                );
                setIsVerifying(false);
                // No automatic redirect on error
            }
        };

        verifyPayment();

        // Cleanup function to remove popstate listener
        return () => {
            window.onpopstate = null;
        };
    }, [sessionId, navigate]);

    // If no session ID, redirect immediately
    if (!sessionId) {
        return <Navigate to="/fees" replace />;
    }

    const handleManualRedirect = () => {
        navigate('/fees', { replace: true });
    };

    return (
        <div className="payment-success">
            <h1>{verified ? 'Payment Successful!' : isVerifying ? 'Verifying Payment...' : 'Payment Verification Issue'}</h1>
            {playerName && <p>Thank you for your payment, {playerName}!</p>}
            
            {verified && (
                <p>You will be redirected to the fees page shortly...</p>
            )}

            {error && (
                <div className="error-message">
                    <h2>Important Note:</h2>
                    <p>There was an issue verifying your payment on our website: {error}</p>
                    
                    {errorDetails && (
                        <div className="error-details">
                            <p><strong>Technical details:</strong></p>
                            <pre>{errorDetails}</pre>
                        </div>
                    )}
                    
                    <div className="important-message">
                        <p><strong>Your payment may still have been processed by Stripe.</strong></p>
                        <p>Please check your email for a payment confirmation from Stripe before attempting another payment.</p>
                    </div>
                    
                    <button 
                        className="primary-button" 
                        onClick={handleManualRedirect}
                    >
                        Continue to Fees Page
                    </button>
                </div>
            )}
        </div>
    );
};

export default PaymentSuccess; 